// Routes met een filmkop: de film loopt achter de doorzichtige kopbalk door en
// het logo is wit met de oranje o (Dennis 28-10-2026).
// Homepage, categorieën, gewone deal- en voucherdetails, de Exclusive-hub en
// bekende belevingsadressen doen mee; Exclusive-hoteldetails blijven uitgesloten.
import { LUXE_BELEVING_ADRESSEN } from "./luxe/luxe-beleving-adressen";
import { isLuxeCategorySegment } from "./luxe-path.mjs";
import { SLUG_SEGMENT_I18N, VOUCHER_PATH_SEGMENTS } from "./slug-paths.js";
import { isRedeemPath } from "./redeem-paths.js";

const belevingspaden = new Set(Object.values(LUXE_BELEVING_ADRESSEN).map(adres => `/exclusive/${adres}`));

const REIS_DETAIL_SEGMENTEN = new Set(
  ["rondreizen", "verre-reizen"].flatMap((segment) => [
    segment,
    ...Object.values(SLUG_SEGMENT_I18N[segment] || {}),
  ]),
);

/** Deal-details, inclusief de canonieke reisroutes; nooit hun overzichten. */
export function isDealFilmKopRoute(normalizedPathname) {
  if (typeof normalizedPathname !== "string") return false;
  const reis = /^\/([^/?#]+)\/[^/?#]+\/?$/.exec(normalizedPathname);
  if (reis && REIS_DETAIL_SEGMENTEN.has(reis[1])) return true;
  const match = /^\/packages\/([^/?#]+)\/[^/?#]+\/?$/.exec(normalizedPathname);
  if (!match) return false;
  let category;
  try {
    category = decodeURIComponent(match[1]).toLowerCase();
  } catch {
    return false;
  }
  // `view` hoort bij /packages/view/<categorie>/<slug>, nooit bij een dealcategorie.
  return !isLuxeCategorySegment(category) &&
    !["exclusive", "view"].includes(category);
}

/**
 * Alleen de detailpagina van één voucherdeal: /vouchers/<id-of-slug>, ook onder
 * de gelokaliseerde segmenten (gutscheine, bons-cadeaux, vouchery). Niet het
 * overzicht, niet de verzilverroutes, niet dieper gelegen paden.
 */
export function isVoucherFilmKopRoute(normalizedPathname) {
  if (typeof normalizedPathname !== "string") return false;
  const match = /^\/([^/?#]+)\/[^/?#]+\/?$/.exec(normalizedPathname);
  if (!match || !VOUCHER_PATH_SEGMENTS.includes(match[1])) return false;
  return !isRedeemPath(normalizedPathname);
}

/** Detailroutes waar een weergave zonder film zich kan afmelden (deal of voucher). */
export function isDetailFilmKopRoute(normalizedPathname) {
  return isDealFilmKopRoute(normalizedPathname) || isVoucherFilmKopRoute(normalizedPathname);
}

/**
 * `normalizedPathname` komt uit stripLocalePrefix (tegenwoordig alleen slash-normalisatie).
 * Homepage, categorieën, gewone deal- en voucherdetails en de Exclusive-hub en
 * bekende belevingsadressen, met of zonder afsluitende slash.
 */
export function isFilmKopRoute(normalizedPathname) {
  if (typeof normalizedPathname !== "string") return false;
  if (normalizedPathname === "/") return true;
  const pad = normalizedPathname.replace(/\/$/, "");
  if (pad === "/exclusive" || belevingspaden.has(pad)) return true;
  return /^\/packages\/[^/]+\/?$/.test(normalizedPathname) || isDetailFilmKopRoute(normalizedPathname);
}
